import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import _ from "lodash";
import { Translate, I18n } from "react-redux-i18n";
import Utilities from "../../Helpers/Utilities";
import { updateKitQuantity } from "../../Store/Catalog/Actions";
import { updateTempCart, updateTempCartKitUI } from "../../Store/Cart/Actions";
import { onFinish } from "../../Store/Wizard/Actions";

class KitPricingSummary extends Component {
    constructor(props) {
        super(props);

        this.onQuantityChange = this.onQuantityChange.bind(this);
        this.proceedCheckout = this.proceedCheckout.bind(this);
    }

    onQuantityChange(quantity) {
        const { updateKitQuantity, updateTempCart, updateTempCartKitUI, tempCart, tempCartKitUI } = this.props;

        quantity = quantity === "" ? 0 : parseInt(quantity);
        updateKitQuantity(quantity);

        // update UI temp cart for display all items, just parent item is used for real temp cart through controller adding required to cart
        if (tempCartKitUI.Kit) {
            const kitObj = tempCartKitUI.Kit;
            const selectedKit = _.map(kitObj, obj => obj)[0];
            updateTempCartKitUI({ ["Kit"]: { [selectedKit.id]: { ...selectedKit, quantity: quantity } } });
        }
        if (tempCartKitUI.Plan) {
            const carrierObj = tempCartKitUI.Plan;
            const selectedCarrier = _.map(carrierObj, obj => obj)[0];
            updateTempCartKitUI({ ["Plan"]: { [selectedCarrier.id]: { ...selectedCarrier, quantity: quantity } } });
        }

        _.each(tempCartKitUI, (category) => {
            _.each(category, (product) => {
                if (product.parentCategory === "Charging Accessories") {
                    updateTempCartKitUI({ ["ChargingAccessory-" + product.id]: { [product.id]: { ...product, quantity: product.dummyQuantity * quantity } } });
                } else if (product.parentCategory === "Optional Accessories") {
                    updateTempCartKitUI({ ["OptionalAccessory-" + product.id]: { [product.id]: { ...product, quantity: product.dummyQuantity * quantity } } });
                }
            });
        });

        // update actual temp cart for cart summary and checkout
        if (tempCart.Kit) {
            const kitObj = tempCart.Kit;
            const selectedKit = _.map(kitObj, obj => obj)[0];
            updateTempCart({ ["Kit"]: { [selectedKit.id]: { ...selectedKit, quantity: quantity } } });
        }
        if (tempCart.Plan) {
            const carrierObj = tempCart.Plan;
            const selectedCarrier = _.map(carrierObj, obj => obj)[0];
            updateTempCart({ ["Plan"]: { [selectedCarrier.id]: { ...selectedCarrier, quantity: quantity } } });
        }

        _.each(tempCart, (category) => {
            _.each(category, (product) => {
                if (product.parentCategory === "Charging Accessories") {
                    updateTempCart({ ["ChargingAccessory-" + product.id]: { [product.id]: { ...product, quantity: quantity } } });
                } else if (product.parentCategory === "Optional Accessories") {
                    updateTempCart({ ["OptionalAccessory-" + product.id]: { [product.id]: { ...product, quantity: quantity } } });
                }
            });
        });
    }

    proceedCheckout() {
        const { wizards, onFinish } = this.props;
        if (wizards.KitsBuild.currentStep === 4) {
            onFinish("KitsBuild");
        }
    }

    render() {
        const { tempCartKitUI, tempWirelessPlan, kitQuantity, wizards } = this.props;

        // Using the UI temp cart to show quantities and pricing for items selected
        // Device
        let devicePrice = 0;
        let deviceQuantity = 0;
        let kitObj;
        let selectedKit;

        if (tempCartKitUI.Kit) {
            kitObj = tempCartKitUI.Kit;
            selectedKit = _.map(kitObj, obj => obj)[0];
            deviceQuantity = selectedKit.quantity;
            devicePrice = selectedKit.productPrice.priceValue * kitQuantity;
        }

        // Carrier
        let carrierPrice = 0;
        let carrierQuantity = 0;
        if (tempCartKitUI.Plan) {
            const carrierObj = tempCartKitUI.Plan;
            const selectedCarrier = _.map(carrierObj, obj => obj)[0];
            carrierQuantity = selectedCarrier.quantity;
            // check if the selected plan has product attributes, and also check if the selected carrier has an attribute price from the radio button selection
            // > if so, use the temp wireless attribute price
            // > else use the 0 price for the no data plan selection
            if (selectedCarrier.productAttributes && selectedCarrier.productAttributes.length > 0 && tempWirelessPlan.productAttributePrice) {
                carrierPrice = tempWirelessPlan.productAttributePrice * carrierQuantity;
            } else {
                carrierPrice = selectedCarrier.productPrice.priceValue * carrierQuantity;
            }
        }

        // Charging Accessories
        let chargingPrice = 0;
        let chargingQuantity = 0;
        // Optional Accessories
        let optionalPrice = 0;
        let optionalQuantity = 0;

        let chargingItems = [];
        let optionalItems = [];
        _.each(tempCartKitUI, item => {
            const itemObj = _.map(item, obj => obj)[0];
            if (itemObj.parentCategory === "Charging Accessories") {
                chargingItems.push(itemObj);
            }
            if (itemObj.parentCategory === "Optional Accessories") {
                optionalItems.push(itemObj);
            }
        });

        if (tempCartKitUI) {

            chargingQuantity = _.reduce(chargingItems, function(sum, n) {
                return sum + n.quantity;
            }, 0);
            optionalQuantity = _.reduce(optionalItems, function(sum, n) {
                return sum + n.quantity;
            }, 0);

            _.each(chargingItems, item => {
                chargingPrice += item.productPrice.priceValue * item.quantity;
            });

            _.each(optionalItems, item => {
                optionalPrice += item.productPrice.priceValue * item.quantity;
            });
        }

        // Total
        // took out carrier price since its not due now, but is monthly recurring
        const totalPrice = devicePrice + chargingPrice + optionalPrice;

        return (
            <div className="pricing-table-container">
                <div className="kit-pricing-table">
                    <h4><Translate value="buildAKit.kitPricingSummary.title" /></h4>
                    <table>
                        <tbody>
                            <tr>
                                <td><Translate value="buildAKit.kitPricingSummary.devices" /></td>
                                <td className="device-qty table-qty">{deviceQuantity}</td>
                                <td className="device-price table-price">{Utilities.formatPrice(devicePrice)}</td>
                            </tr>
                            <tr>
                                <td><Translate value="buildAKit.kitPricingSummary.dataPlans" /></td>
                                <td className="carrier-qty table-qty">{carrierQuantity}</td>
                                <td className="carrier-price table-price">{Utilities.formatPrice(tempCartKitUI.Plan ? carrierPrice : 0)}</td>
                            </tr>
                            <tr>
                                <td><Translate value="buildAKit.kitPricingSummary.chargingAccessories" /></td>
                                <td className="charging-qty table-qty">{chargingQuantity}</td>
                                <td className="charging-price table-price">{Utilities.formatPrice(chargingPrice > 0 && chargingQuantity > 0 ? chargingPrice : 0)}</td>
                            </tr>
                            <tr>
                                <td><Translate value="buildAKit.kitPricingSummary.optionalAccessories" /></td>
                                <td className="optional-qty table-qty">{optionalQuantity}</td>
                                <td className="optional-price table-price">{Utilities.formatPrice(optionalPrice > 0 && optionalQuantity > 0 ? optionalPrice : 0)}</td>
                            </tr>
                            <tr className="price-total-row">
                                <td><Translate value="buildAKit.kitPricingSummary.title" /></td>
                                <td className="table-qty"/>
                                <td className="total-price table-price">{Utilities.formatPrice(totalPrice > 0 ? totalPrice : 0)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className="row kit-number-row">
                    <div className="col-4 col-sm-4 col-md-5 col-lg-4">
                        <h5><Translate value="buildAKit.kitPricingSummary.numberOfKits" />:</h5>
                    </div>
                    <div className="col-3 col-sm-2 col-md-3 col-lg-2">
                        <input type="number" placeholder={I18n.t("abbreviations.quantity")} min={0} value={selectedKit ? selectedKit.quantity : 1} onChange={e => this.onQuantityChange(e.target.value)}/>
                    </div>
                    <div className="col-4 col-sm-5 offset-sm-1 col-md-4 offset-md-0 col-lg-5 offset-lg-1">
                        <button type="button" className={`btn btn--primary ${wizards.KitsBuild.currentStep !== 4 ? "disabled" : ""}`} style={{ width: "100%" }} onClick={this.proceedCheckout} ><Translate value="misc.addToCart" /></button>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        i18n: state.i18n,
        wizards: state.wizards,
        tempWirelessPlan: state.tempWirelessPlan,
        tempCartKitUI: state.tempCartKitUI
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateKitQuantity: updateKitQuantity,
        updateTempCart: updateTempCart,
        updateTempCartKitUI: updateTempCartKitUI,
        onFinish: onFinish
    }, dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(KitPricingSummary));